import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from './axios';
import { RootState } from '../store';
import { DeviceFormValues } from '../../pages/Device/DeviceSettings';

export const getDevicesCombined = createAsyncThunk('devices-get', async (_, { getState }) => {
    const state = getState() as RootState;

    const { trailDurations } = state.device;
    const hunterTrailDurations = state.hunter.trailDurations;
    const { disabledDogFilters, mapFilters } = state.map;

    const filteredTrailDurations = Object.keys(trailDurations)
        .filter((t: any) => !disabledDogFilters.includes(t))
        .reduce((cur, key) => {
            return Object.assign(cur, { [key]: trailDurations[Number(key)] });
        }, {});

    const url = `devices/devices-trails?dogFilters=&filters=${JSON.stringify(mapFilters)}&hunterFrom=&from=`;
    // const url = `devices/devices-trails?dogFilters=${disabledDogFilters}&filters=${JSON.stringify(
    //     mapFilters,
    // )}&hunterFrom=${JSON.stringify(hunterTrailDurations)}&from=${JSON.stringify(filteredTrailDurations)}`;

    const response = await axios.get(url);

    // console.log('getDevicesCombined', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data;
    } else {
        throw 'error';
    }
});

export const getActiveDevice = createAsyncThunk('device/get-active', async ({ id }: { id: number }) => {
    const response = await axios.get(`devices/${id}`);

    // console.log('getActiveDevice', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return response.data.data;
    } else {
        throw 'error';
    }
});

export const updateDevice = createAsyncThunk(
    'device/update',
    async ({ id, data }: { id: number; data: DeviceFormValues }) => {
        const response = await axios.put(`devices/${id}`, data);

        if (response.status === 200 && typeof response.data === 'object' && response.data.status === 200) {
            return true;
        } else {
            throw 'error';
        }
    },
);
export const updateDevicePhoto = createAsyncThunk(
    'device/update-photo',
    async ({ id, file }: { id: number; file: Blob }) => {
        const formData = new FormData();
        formData.append('file', file, 'team-image.jpg');

        const response = await axios.post(`devices/${id}/upload/photo?aws=1`, formData);

        if (response.status === 200 && typeof response.data === 'object') {
            return true;
        } else {
            throw 'error';
        }
    },
);

export const deleteDevicePhoto = createAsyncThunk('device/delete-photo', async ({ id }: { id: number }) => {
    const response = await axios.delete(`devices/${id}/delete/photo?aws=1`);

    // console.log('deleteDevicePhoto', response.data);
    if (response.status === 200 && typeof response.data === 'object') {
        return true;
    } else {
        throw 'error';
    }
});

export const performRequestDeviceLocationCommand = createAsyncThunk(
    'device/single-locate',
    async ({ id }: { id: number }) => {
        const response = await axios.put(`devices/location/${id}`);

        // console.log('performRequestDeviceLocationCommand', response.data);
        if (response.status === 200 && typeof response.data === 'object') {
            return true;
        } else {
            return false;
        }
    },
);

export const performDeviceCommand = createAsyncThunk(
    'device/command',
    async (data: { id: number; setting: string; value: number | string; command_id: boolean | number }) => {
        const response = await axios.put(`devices/settings/${data.id}`, data);

        // console.log('performDeviceCommand', response.data);
        return response.data;
    },
);

export const changeComment = createAsyncThunk(
    'device/change-comment',
    async ({ deviceId, comment }: { deviceId: number; comment: string }) => {
        const response = await axios.put(`devices/change-comment/${deviceId}`, { comment });
        // console.log('respo', response.data);
        if (response.status === 200 && typeof response.data === 'object') {
            return response.data;
        } else {
            throw 'error';
        }
    },
);

export const removeCommandFromQueue = createAsyncThunk('device/remove-command', async ({ id }: { id: number }) => {
    const response = await axios.post(`devices/remove-command/${id}`);

    // console.log('removeCommandFromQueue', response.data);
    return response.data;
});

export const updateSpeedAlarmAttribute = createAsyncThunk(
    'device/updateSpeedAlarmAttribute',
    async (data: {
        id: number;
        myDevice: boolean;
        userId: number;
        setting: string;
        value: number;
        type: string;
        attributes: string;
    }) => {
        const response = await axios.put(`devices/alarms/${data.id}`, data);

        // console.log('updateSpeedAlarmAttribute', response.data);
        return response.data;
    },
);

export const updateLowBatteryAlarm = createAsyncThunk(
    'device/updateLowBatteryAlarm',
    async (data: {
        id: number;
        myDevice: boolean;
        userId: number;
        setting: string;
        value: number;
        type: string;
        attributes: string;
    }) => {
        const response = await axios.put(`devices/alarms/${data.id}`, data);

        // console.log('updateLowBatteryAlarm', response.data);
        return response.data;
    },
);

export const updateStopAlarm = createAsyncThunk(
    'device/updateStopAlarm',
    async (data: {
        id: number;
        myDevice: boolean;
        userId: number;
        setting: string;
        value: number;
        type: string;
        attributes: string;
    }) => {
        const response = await axios.put(`devices/alarms/${data.id}`, data);

        // console.log('updateStopAlarm', response.data);
        return response.data;
    },
);

export const updatePowerOffAlarm = createAsyncThunk(
    'device/updatePowerOffAlarm',
    async (data: {
        id: number;
        myDevice: boolean;
        userId: number;
        setting: string;
        value: number;
        type: string;
        attributes: string;
    }) => {
        const response = await axios.put(`devices/alarms/${data.id}`, data);

        // console.log('updatePowerOffAlarm', response.data);
        return response.data;
    },
);

export const updateGeofenceAlarm = createAsyncThunk(
    'device/updateGeofenceAlarm',
    async (data: {
        id: number;
        myDevice: boolean;
        userId: number;
        setting: string;
        value: number;
        type: string;
        attributes: string;
    }) => {
        const response = await axios.put(`devices/alarms/${data.id}`, data);

        // console.log('updateGeofenceAlarm', response.data);
        return response.data;
    },
);
